import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from "../components/api";
import { generateNorthstarReportByNirman } from '../components/api';

function NorthstarForm() {
  const location = useLocation();
  const { patientId, technicianId, serviceId } = location.state || {};
  const [realPatientId, setRealPatientId] = useState(null);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    sex: '',
    dateOfBirth: '',
    age: '',
    department: '',
    employeeCode: '',
    height: '',
    weight: '',
    pulse: '',
    bloodPressure: '',
    allergy: '',
    medicalHistory: '',
    surgicalHistory: '',
    signsSymptoms: '',
    vision: '',
    skin: '',
    remarks: ''
  });


useEffect(() => {
  if (!patientId) return;

  const loadData = async () => {
    try {
      // 1️⃣ Fetch patient using unique_patient_id (PAT-XXXX)
      const patient = await fetchPatientBasicDetails(patientId);

      // 🔥 STORE INTEGER ID
      setRealPatientId(patient.id);

      // 2️⃣ Fill form from PatientData
      setFormData(prev => ({
        ...prev,
        name: patient.patient_name || '',
        sex: patient.gender || '',
        dateOfBirth: patient.dob || '',
        age: patient.age ? patient.age.toString() : '',
        employeeCode: patient.nirman_number || '',
      }));

      // 3️⃣ Fetch Northstar form USING INTEGER ID
      try {
        const form = await fetchNorthstarForm(patient.id);

        setFormData(prev => ({
          ...prev,
          department: form.department || '',
          height: form.height || '',
          weight: form.weight || '',
          pulse: form.pulse || '',
          bloodPressure: form.blood_pressure || '',
          allergy: form.allergy || '',
          medicalHistory: form.medical_history || '',
          surgicalHistory: form.surgical_history || '',
          signsSymptoms: form.signs_symptoms || '',
          vision: form.vision || '',
          skin: form.skin || '',
          remarks: form.remarks || '',
        }));
      } catch {
        console.log("Northstar form not created yet");
      }

    } catch (err) {
      console.error(err);
      alert("Unable to load data");
    }
  };

  loadData();
}, [patientId]);






  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Auto-calculate age when date of birth changes
    if (name === 'dateOfBirth' && value) {
      const birthDate = new Date(value);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setFormData(prev => ({
        ...prev,
        age: age.toString()
      }));
    }
  };

const fetchPatientBasicDetails = async (patientId) => {
  const res = await api.get(`/campmanager/patient/${patientId}/`);
  return res.data; 
};

const fetchNorthstarForm = async (patientId) => {
  const res = await api.get(`/campmanager/northstar-form/${patientId}/`);
  return res.data;
};

//   const handleSubmit = async () => {
//   try {
//     const payload = {
//       patient_name: formData.name,
//       gender: formData.sex,
//       dob: formData.dateOfBirth,
//       age: Number(formData.age),
//       department: formData.department,
//       nirman_number: formData.employeeCode,

//       height: formData.height || null,
//       weight: formData.weight || null,
//       pulse: formData.pulse || null,
//       blood_pressure: formData.bloodPressure || "",

//       allergy: formData.allergy,
//       medical_history: formData.medicalHistory,
//       surgical_history: formData.surgicalHistory,

//       signs_symptoms: formData.signsSymptoms,
//       vision: formData.vision,
//       skin: formData.skin,
//       remarks: formData.remarks,
//     };

//     if (!realPatientId) {
//       alert("Patient not loaded yet");
//       return;
//     }

//     // 1️⃣ SAVE NORTHSTAR FORM
//     await api.post(
//       `/campmanager/northstar-form/${realPatientId}/`,
//       payload
//     );

//     // 2️⃣ TECHNICIAN SERVICE SUBMIT
//     if (technicianId && serviceId) {
//       const technicianPayload = {
//         patient_id: patientId, // unique_patient_id (PAT-XXXX)
//         technician_id: technicianId,
//         service_id: serviceId,
//       };

//       await api.post(
//         `/technician/submit/`,
//         technicianPayload
//       );
//     }

//     // 3️⃣ GENERATE & DOWNLOAD REPORT (USING NIRMAN NUMBER)
//     // const nirmanNumber = formData.employeeCode;

//     // if (!nirmanNumber) {
//     //   alert("Nirman number not found, report not generated");
//     // } else {
//     //   const response = await api.get(
//     //     `campmanager/northstar/generate-report/${nirmanNumber}/`,
//     //     { responseType: "blob" }
//     //   );

//     //   const pdfBlob = new Blob([response.data], {
//     //     type: "application/pdf",
//     //   });

//     //   const url = window.URL.createObjectURL(pdfBlob);
//     //   const link = document.createElement("a");
//     //   link.href = url;
//     //   link.download = `Northstar_Report_${nirmanNumber}.pdf`;
//     //   document.body.appendChild(link);
//     //   link.click();
//     //   link.remove();
//     //   window.URL.revokeObjectURL(url);
//     // }

//     alert("Northstar form saved & report generated successfully ✅");

//     // 4️⃣ GO BACK TO DASHBOARD
//     navigate(-1);

//   } catch (err) {
//     console.error(err);
//     alert("Failed to save Northstar form ❌");
//   }
// };
  const handleSubmit = async () => {
    try {
      const payload = {
        patient_name: formData.name,
        gender: formData.sex,
        dob: formData.dateOfBirth,
        age: Number(formData.age),
        department: formData.department,
        nirman_number: formData.employeeCode,

        height: formData.height || null,
        weight: formData.weight || null,
        pulse: formData.pulse || null,
        blood_pressure: formData.bloodPressure || "",

        allergy: formData.allergy,
        medical_history: formData.medicalHistory,
        surgical_history: formData.surgicalHistory,

        signs_symptoms: formData.signsSymptoms,
        vision: formData.vision,
        skin: formData.skin,
        remarks: formData.remarks,
      };

      if (!realPatientId) {
        alert("Patient not loaded yet");
        return;
      }

      // 1️⃣ SAVE NORTHSTAR FORM
      await api.post(`/campmanager/northstar-form/${realPatientId}/`, payload);

      // 2️⃣ TECHNICIAN SERVICE SUBMIT
      if (technicianId && serviceId) {
        const technicianPayload = {
          patient_id: patientId, // unique_patient_id (PAT-XXXX)
          technician_id: technicianId,
          service_id: serviceId,
        };

        await api.post(`/technician/submit/`, technicianPayload);
      }

      // 3️⃣ GENERATE PDF ON BACKEND (WITHOUT DOWNLOADING)
      const nirmanNumber = formData.employeeCode;
      if (nirmanNumber) 
        await api.post(
          `/campmanager/northstar/generate-report/${nirmanNumber}/`
        );

      alert("Northstar form saved & report generated successfully ✅");

      // 4️⃣ GO BACK TO DASHBOARD
      navigate(-1);

    } catch (err) {
      console.error(err);
      alert("Failed to save Northstar form ❌");
    }
  };



  const handleReset = () => {
    setFormData({
      name: '',
      sex: '',
      dateOfBirth: '',
      age: '',
      department: '',
      employeeCode: '',
      height: '',
      weight: '',
      pulse: '',
      bloodPressure: '',
      allergy: '',
      medicalHistory: '',
      surgicalHistory: '',
      signsSymptoms: '',
      vision: '',
      skin: '',
      remarks: ''
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-xl p-8">
        <h1 className="text-3xl font-bold text-indigo-900 mb-6 text-center">
          Northstar Medical Examination Form
        </h1>
        
        <div className="space-y-6">
          {/* Personal Information Section */}
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Personal Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Name of Worker *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Sex *
                </label>
                <select
                  name="sex"
                  value={formData.sex}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Date of Birth *
                </label>
                <input
                  type="date"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Age
                </label>
                <input
                  type="number"
                  name="age"
                  value={formData.age}
                  onChange={handleChange}
                  readOnly
                  className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Department Works *
                </label>
                <input
                  type="text"
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Employee Code *
                </label>
                <input
                  type="text"
                  name="employeeCode"
                  value={formData.employeeCode}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>
            </div>
          </div>

          {/* Physical Measurements Section */}
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Physical Measurements</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Height (cm)
                </label>
                <input
                  type="number"
                  name="height"
                  value={formData.height}
                  onChange={handleChange}
                  step="0.1"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Weight (kg)
                </label>
                <input
                  type="number"
                  name="weight"
                  value={formData.weight}
                  onChange={handleChange}
                  step="0.1"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Pulse (bpm)
                </label>
                <input
                  type="number"
                  name="pulse"
                  value={formData.pulse}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Blood Pressure (e.g., 120/80)
                </label>
                <input
                  type="text"
                  name="bloodPressure"
                  value={formData.bloodPressure}
                  onChange={handleChange}
                  placeholder="120/80"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>
            </div>
          </div>

          {/* Medical History Section */}
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Medical History</h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Allergy (If Any)
                </label>
                <textarea
                  name="allergy"
                  value={formData.allergy}
                  onChange={handleChange}
                  rows="2"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="List any allergies..."
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Medical History
                </label>
                <textarea
                  name="medicalHistory"
                  value={formData.medicalHistory}
                  onChange={handleChange}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Past medical conditions, chronic illnesses..."
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Surgical History
                </label>
                <textarea
                  name="surgicalHistory"
                  value={formData.surgicalHistory}
                  onChange={handleChange}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Previous surgeries..."
                />
              </div>
            </div>
          </div>

          {/* Examination Findings Section */}
          <div className="pb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Examination Findings</h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Signs and Symptoms Observed During Examination
                </label>
                <textarea
                  name="signsSymptoms"
                  value={formData.signsSymptoms}
                  onChange={handleChange}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Observations during examination..."
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vision
                  </label>
                  <input
                    type="text"
                    name="vision"
                    value={formData.vision}
                    onChange={handleChange}
                    placeholder="e.g., 20/20"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Skin
                  </label>
                  <input
                    type="text"
                    name="skin"
                    value={formData.skin}
                    onChange={handleChange}
                    placeholder="Condition of skin..."
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Remarks (If Any)
                </label>
                <textarea
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  placeholder="Additional notes or remarks..."
                />
              </div>
            </div>
          </div>

          {/* Form Actions */}
          <div className="flex gap-4 justify-end pt-4">
            <button
              type="button"
              onClick={handleReset}
              className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Reset
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              className="px-6 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors"
            >
              Submit Form
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NorthstarForm;